import * as yup from 'yup'
// import { COUNTRY_CODES, validatePhoneForCountry } from '@common/countryCodes'

// OTP validation schema
export const otpSchema = yup.object({
    otp: yup
        .string()
        .required('Please enter the complete 6-digit code')
        .length(6, 'OTP must be exactly 6 digits')
        .matches(/^\d{6}$/, 'OTP must contain only numbers'),
})

// Email + password login schema
export const emailLoginSchema = yup.object({
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
    password: yup.string().required('Password is required'),
    isRememberMe: yup.boolean().default(false),
})

// Email + password registration schema (without phone)
export const emailRegistrationSchema = yup.object({
    name: yup
        .string()
        .required('Name is required')
        .min(2, 'Name must be at least 2 characters')
        .max(50, 'Name must be less than 50 characters'),
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
    password: yup
        .string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number'),
    confirmPassword: yup
        .string()
        .required('Please confirm your password')
        .oneOf([yup.ref('password')], 'Passwords must match'),
    agreeToPrivacyPolicy: yup
        .boolean()
        .oneOf([true], 'You must agree to the privacy policy')
        .required('You must agree to the privacy policy'),
})

// Email validation schema
export const emailSchema = yup.object({
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
})

// Require OTP schema (for resend verification)
export const requireOTPSchema = yup.object({
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
})

// Member data validation schema
export const memberDataSchema = yup.object({
    name: yup.string().required('Name is required').min(2, 'Name must be at least 2 characters'),
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
    phone: yup
        .string()
        .required('Phone number is required')
        .matches(/^\+?[\d\s\-()]+$/, 'Please enter a valid phone number'),
})

// Request password reset schema
export const requestPasswordResetSchema = yup.object({
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
})

// Reset password schema
export const resetPasswordSchema = yup.object({
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
    token: yup.string().required('Reset token is required'),
    newPassword: yup
        .string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number'),
    confirmPassword: yup
        .string()
        .required('Please confirm your password')
        .oneOf([yup.ref('newPassword')], 'Passwords must match'),
})
